// 한국어 — mirrors en.js key for key. ko only uses the CLDR "other" plural
// category, so plural entries only carry the _other form.
const ko = {
  // ===== shared =====
  'common.createPlan': '플랜 만들기',
  'common.save': '저장',
  'common.cancel': '취소',
  'common.delete': '삭제',
  'common.edit': '편집',
  'common.retry': '다시 시도',
  'common.activate': '활성화',
  'common.deactivate': '비활성화',
  'common.enabled': '사용',
  'common.disabled': '사용 안 함',
  'common.viewTerms': '약관 보기',
  'common.untitledPlan': '제목 없는 플랜',
  'common.savedToast': '저장되었습니다',

  // ===== nav / chrome =====
  'nav.home': '홈',
  'nav.plans': '플랜',
  'nav.settings': '설정',

  'mismatch.title': '배포 환경 불일치',
  'mismatch.body': '이 프런트엔드 빌드는 {apiBase}를 호출하지만, 현재 {hostname}에서 제공되고 있습니다(예상: {expected}).',
  'mismatch.contact': '기술 지원팀에 문의하세요 — 배포 설정 오류이며 계정 문제가 아닙니다.',

  'install.title': 'Shopify에 연결할 수 없습니다',
  'install.body': '백엔드가 실행 중인지, 그리고 SHOPIFY_API_KEY가 shopify.app.toml에 있는 앱의 client_id와 일치하는지 확인하세요.',
  'install.retry': '다시 시도',

  'chrome.loadingBrand': 'FlexCover 로드 중…',
  'error.title': '문제가 발생했습니다',
  'error.reload': '다시 로드',

  'support.badge': '지원 화면',
  'support.shopUnknown': '(스토어 알 수 없음)',
  'support.expired': '토큰이 만료되었습니다 — 지원 콘솔에서 다시 생성하세요',
  'support.validUntil': '토큰 유효 기간: {time}까지',
  'support.exit': '나가기',

  // ===== Home =====
  'home.title': 'FlexCover: Protection Plans에 오신 것을 환영합니다 👋',
  'home.last30days': '최근 30일',
  'home.loadingChart': '차트 로드 중',
  'home.loadingOverview': '개요 로드 중',
  'home.statOrders': '플랜이 포함된 주문',
  'home.statRevenue': '총 플랜 수익',
  'home.gettingStarted': '시작하기',
  'home.allSet': '모두 완료 🎉',
  'home.completed': '{total}개 중 {done}개 완료',
  'home.step1.title': '첫 번째 플랜 만들기',
  'home.step1.desc': '보호 서비스의 가격, 보장 범위, 장바구니 표시를 설정하세요.',
  'home.step2.title': '앱 임베드 사용',
  'home.step2.desc': 'FlexCover: Protection Plans 블록을 켜서 장바구니에 위젯이 표시되도록 하세요.',
  'home.step2.enable': '앱 임베드 사용',
  'home.step2.check': '상태 확인',
  'home.step3.title': '첫 번째 보호 주문 받기',
  'home.step3.desc': '위젯이 활성화되면 고객이 장바구니에서 플랜을 추가할 수 있습니다 — 총액은 위 카드에 표시됩니다.',
  'home.appEmbed': '앱 임베드',
  'home.checkingEmbed': '앱 임베드 상태 확인 중',
  'home.embedEnabledBody': '보호 위젯이 스토어프런트에 적용되었습니다.',
  'home.embedTheme': '(테마: {theme})',
  'home.embedDisabledBody': '현재 앱이 스토어프런트에서 활성화되어 있지 않습니다.',
  'home.embedUnknown': '알 수 없음',
  'home.embedUnknownBody': '앱이 스토어에 연결되면 스토어프런트 상태를 확인할 수 있습니다.',
  'home.embedUnknownReason': '지금은 라이브 테마를 읽을 수 없습니다.',
  'home.enableEmbedHint': 'Shopify 관리자에서 온라인 스토어 → 테마 → 사용자 지정 → 앱 임베드로 이동한 다음 FlexCover: Protection Plans를 켜세요.',
  'home.learnMorePrefix': '자세히 보기: ',
  'home.learnMoreLink': '보호 플랜 사용 방법',

  // ===== Plans list =====
  'plans.title': '플랜',
  'plans.loading': '플랜 로드 중',
  'plans.errorTitle': '플랜을 로드할 수 없습니다',
  'plans.empty.heading': '첫 번째 보호 플랜 만들기',
  'plans.empty.body': '배송 보호, 연장 보증, 반품 보험, 맞춤 보장을 제공하세요 — 가격은 직접 정할 수 있습니다.',
  'plans.loadDemo': '데모 플랜 불러오기',
  'plans.demoLoaded': '데모 플랜을 불러왔습니다',
  'plans.demoFailed': '데모 플랜을 불러오지 못했습니다: {message}',
  'plans.filterPlaceholder': '플랜 필터링',
  'plans.addFilter': '필터 추가',
  'plans.statusHeading': '상태',
  'plans.typeHeading': '보호 유형',
  'plans.statusActive': '활성',
  'plans.statusInactive': '비활성',
  'plans.showing_other': '{count}개 플랜 표시 중',
  'plans.sortBy': '정렬 기준',
  'plans.selectAll': '모든 플랜 선택',
  'plans.selectedCount': '{count}개 선택됨',
  'plans.bulkDeleted_other': '{count}개 플랜이 삭제되었습니다',
  'plans.bulkActivated_other': '{count}개 플랜이 활성화되었습니다',
  'plans.bulkDeactivated_other': '{count}개 플랜이 비활성화되었습니다',
  'plans.deleteBulkFailed': '삭제하지 못했습니다: {message}',
  'plans.updateBulkFailed': '업데이트하지 못했습니다: {message}',
  'plans.activated': '플랜이 활성화되었습니다',
  'plans.deactivated': '플랜이 비활성화되었습니다',
  'plans.updateFailed': '플랜 업데이트에 실패했습니다: {message}',
  'plans.deleted': '플랜이 삭제되었습니다',
  'plans.deleteFailed': '플랜 삭제에 실패했습니다: {message}',
  'plans.actionsFor': '{name} 작업',
  'plans.activatePlan': '{name} 활성화',
  'plans.deactivatePlan': '{name} 비활성화',
  'plans.onlineStore': '온라인 스토어',
  'plans.optional': '선택',
  'plans.automatic': '자동',
  'plans.noMatch': '검색 또는 필터와 일치하는 플랜이 없습니다.',
  'plans.deleteTitle': '보호 플랜을 삭제하시겠습니까?',
  'plans.deleteBody': '이(가) 스토어에서 즉시 삭제되며 고객에게는 이 보호 옵션이 더 이상 표시되지 않습니다.',
  'plans.helpPrefix': '도움이 필요하신가요? ',
  'plans.helpLink': '문의하기',
  'plans.helpSuffix': ' 또는 앱 문서와 사용법 튜토리얼을 확인하세요.',

  'sort.date': '날짜(최신순)',
  'sort.name': '이름(A–Z)',
  'sort.sortOrder': '장바구니 순서',
  'sort.price': '가격(낮은순)',

  'planType.shipping_protection': '배송 보호',
  'planType.warranty': '연장 보증',
  'planType.return_insurance': '반품 보험',
  'planType.custom': '맞춤 보호',
  'planTypeShort.shipping_protection': '배송',
  'planTypeShort.warranty': '보증',
  'planTypeShort.return_insurance': '반품',
  'planTypeShort.custom': '맞춤',
  'priceType.fixed': '고정 금액',
  'priceType.percentage': '주문 금액 비율',

  // ===== Plan editor page shell =====
  'plan.pageTitle': '보호 플랜',
  'plan.loading': '플랜 로드 중',
  'plan.notFound.heading': '플랜을 찾을 수 없습니다',
  'plan.notFound.body': '이 보호 플랜은 삭제되었을 수 있습니다.',
  'plan.backToPlans': '플랜 목록으로 돌아가기',
  'plan.newTitle': '새 보호 플랜',
  'plan.newSubtitle': '가격과 장바구니 표시를 설정한 후 플랜을 만드세요',
  'plan.subtitle': '저장해야 변경 사항이 스토어에 적용됩니다',
  'plan.statusTitle': '플랜 상태',
  'plan.saveFailed': '플랜 저장에 실패했습니다: {message}',

  // ===== Plan editor form =====
  'form.section.type': '보호 유형',
  'form.section.basics': '플랜 기본 정보',
  'form.section.pricing': '{type} 가격 책정',
  'form.pricingFallback': '보호',
  'form.section.appearance': '모양',
  'form.section.fulfillment': '이행',

  'form.type.shipping_protection': '배송 보호',
  'form.type.shipping_protection.help': '배송 중 분실, 파손, 도난으로부터 고객의 주문을 보호합니다.',
  'form.type.warranty': '연장 보증',
  'form.type.warranty.help': '제조 결함 및 정상적인 마모를 정해진 기간 동안 보장합니다.',
  'form.type.return_insurance': '반품 보험',
  'form.type.return_insurance.help': '고객이 기간 내에 상품을 반품하면 전액 환불됩니다.',
  'form.type.custom': '맞춤 보호',
  'form.type.custom.help': '직접 작성한 보장 메시지를 사용합니다.',

  'form.defaults.untitledPlan': '제목 없는 플랜',
  'form.defaults.viewTerms': '약관 보기',
  'form.defaults.shipping_protection.displayName': '배송 보호',
  'form.defaults.shipping_protection.description': '배송 중 분실, 파손, 도난으로부터 주문을 보호합니다.',
  'form.defaults.warranty.displayName': '연장 보증',
  'form.defaults.warranty.description': '2년 동안 제조 결함 및 정상적인 마모를 보장합니다.',
  'form.defaults.return_insurance.displayName': '반품 보험',
  'form.defaults.return_insurance.description': '14일 이내에 상품을 반품하면 전액 환불됩니다.',
  'form.defaults.custom.displayName': '보호 플랜',
  'form.defaults.custom.description': '주문에 보호를 추가하세요.',

  'form.lang.select': '언어 선택',
  'form.lang.default': '{name}(기본값)',
  'form.translated': '(번역됨)',

  'form.field.planName.label': '플랜 이름(내부)',
  'form.field.planName.help': '참고용으로만 사용 — 고객에게는 표시되지 않습니다',
  'form.field.nameRequired': '내부 이름을 입력하세요',
  'form.field.displayName.label': '표시 이름',
  'form.field.displayNameRequired': '표시 이름을 입력하세요',
  'form.field.displayName.placeholder': '표시 이름',
  'form.field.displayName.help': '장바구니와 결제 페이지에서 고객에게 표시됩니다',
  'form.field.displayName.helpPreset': '{lang}(으)로 탐색하는 고객에게 표시됩니다',
  'form.field.displayName.helpPresetFallback': '{lang}(으)로 탐색하는 고객에게 표시됩니다 — 비워 두면 {primary}(으)로 대체됩니다',
  'form.field.description.label': '설명',
  'form.field.description.placeholder': '설명',
  'form.field.description.help': '플랜 이름 아래에 표시되는 짧은 고객용 설명입니다',
  'form.field.disabledDescription.label': '선택 해제 시 설명',
  'form.field.disabledDescription.placeholder': '선택 사항 — 플랜이 선택되지 않았을 때 표시됩니다',
  'form.field.disabledDescription.help': '플랜 체크박스가 해제되었을 때 표시됩니다(비워 두면 위의 설명으로 대체됩니다)',
  'form.field.footer.label': '푸터',
  'form.field.footerText.label': '푸터 텍스트',
  'form.field.footerLink.label': '푸터 링크',
  'form.field.footerLink.help': '푸터 텍스트의 링크 대상',

  'form.price.type.label': '가격 유형',
  'form.price.fixed': '금액 ($)',
  'form.price.percentage': '백분율 (%)',
  'form.price.advanced': '고급 설정',
  'form.price.pctSummary': '주문 금액의 {pct}%, ${min}부터 ${inc}씩 증가하여 최대 ${max}까지 — 플랜 상품에 {count}개 변형이 생성됩니다',
  'form.price.tiersSummary_other': '플랜 상품에는 {base} 변형 1개와 장바구니 금액 규칙용 변형 {count}개가 생성됩니다',

  'form.validation.priceRequired': '0보다 큰 값을 입력하세요',
  'form.validation.priceMax100': '백분율은 100을 초과할 수 없습니다',
  'form.validation.warrantyYears': '1~5년 사이의 기간을 입력하세요',
  'form.validation.returnDays': '7~365일 사이의 기간을 입력하세요',
  'form.validation.maxGreaterThanMin': '최댓값은 최솟값보다 커야 합니다',
  'form.validation.variantIdNumeric': '변형 ID는 숫자여야 합니다(숨겨진 플랜 변형의 ID)',

  'form.icon.label': '아이콘',
  'form.icon.useEmoji': '{emoji}을(를) 플랜 아이콘으로 사용',
  'form.icon.removeCustom': '사용자 지정 아이콘을 제거하고 방패 아이콘 사용',
  'form.icon.upload': '사용자 지정 아이콘 이미지 업로드',
  'form.icon.uploadButton': '업로드',
  'form.icon.uploading': '아이콘 업로드 중',
  'form.icon.uploadHelp': '직접 만든 아이콘을 업로드하세요 — PNG, JPEG, GIF 또는 WebP, 최대 5MB.',
  'form.icon.error.notImage': '이미지 파일(PNG, JPEG, GIF 또는 WebP)을 선택하세요.',
  'form.icon.error.tooLarge': '이미지는 5MB 이하여야 합니다.',

  'form.fulfillment.intro': '보호 상품이 이행 처리되는 시점을 선택하세요.',
  'form.fulfillment.manually': '수동으로 이행',
  'form.fulfillment.first_item': '주문의 첫 상품이 이행되면 이행 처리됨',
  'form.fulfillment.all_items': '주문의 다른 모든 상품이 이행되면 이행 처리됨',
  'form.fulfillment.immediately': '주문 생성 직후 이행 처리됨',

  'form.adv.title': '고급 설정',
  'form.adv.minPrice': '최저 가격',
  'form.adv.minPriceHelp': '첫 번째 변형의 가격 — 플랜이 청구하는 최소 요금',
  'form.adv.increment': '증분 금액',
  'form.adv.incrementHelp': '생성되는 변형 간의 가격 단계',
  'form.adv.maxPriceLabel': '최대 가격: ',
  'form.adv.explanation': '플랜 상품에 {buckets}개의 변형이 생성됩니다. 최저 가격 {min}이 하나의 변형을 차지하고 나머지 {rest}개 변형은 {inc}씩 증가하여 최대 가격 {max}에 도달합니다. 결제 시 고객은 장바구니 소계의 {pct}% 이상인 첫 번째 변형을 지불합니다 — 예: $100 장바구니에 2%를 적용하면 $2.00이므로 $3.01 변형이 적용됩니다. ',
  'form.learnMore': '자세히 알아보기',

  'form.tiers.title': '장바구니 금액별 가격 설정',
  'form.tiers.minCol': '최소 장바구니 금액',
  'form.tiers.maxCol': '최대 장바구니 금액',
  'form.tiers.priceCol': '보호 가격',
  'form.tiers.addTier': '새 규칙 추가',
  'form.tiers.deleteTier': '규칙 {index} 삭제',
  'form.tiers.explanation': '각 규칙에는 최솟값, 최댓값, 가격이 필요합니다(규칙은 겹칠 수 있습니다 — 먼저 일치하는 규칙이 적용됩니다). 각 규칙은 플랜 상품에 개별 변형으로 생성됩니다. 장바구니 합계가 어떤 규칙과도 일치하지 않으면 기본 설정의 고정 가격이 적용됩니다. ',
  'form.tiers.error.minRequired': '최소 장바구니 금액을 입력하세요',
  'form.tiers.error.maxRequired': '최대 장바구니 금액을 입력하세요',
  'form.tiers.error.priceRequired': '보호 가격을 입력하세요',
  'form.tiers.error.pricePositive': '가격은 0보다 커야 합니다',
  'form.tiers.error.minMax': '최솟값은 최댓값보다 작거나 같아야 합니다',

  // ===== Save bar =====
  'savebar.unsavedChanges': '저장되지 않은 변경 사항이 있습니다',
  'savebar.discard': '버리기',
  'savebar.saving': '저장 중',

  // ===== Preview panel =====
  'preview.title': '미리보기',
  'preview.simulatedSubtotal': '시뮬레이션된 장바구니 소계',
  'preview.cart': '장바구니',
  'preview.product': '상품',
  'preview.total': '합계',
  'preview.subtotal': '소계',
  'preview.checkout': '결제',
  'preview.noPlans': '아직 활성 플랜이 없습니다 — 고객에게 이 위젯이 표시되지 않습니다.',
  'preview.autoAdded': '자동 추가',
  'preview.unsaved': '저장 안 됨',

  // ===== Settings page =====
  'settings.title': '설정',
  'settings.language.title': '언어 설정',
  'settings.language.help': 'FlexCover에 방문하실 때 표시되는 언어입니다. 스토어의 언어에는 영향을 주지 않습니다.',
  'settings.language.label': '언어',
  'settings.language.updated': '언어가 업데이트되었습니다',
  'settings.language.saveFailed': '언어 설정을 저장하지 못했습니다: {message}'
};

export default ko;
